import React from 'react'
import './MobBigHero.css'
import logo from "./../../../Assets/Vector.png"
import burger from "./../../../Assets/icon.png"
import social from "./../../../Assets/social_phone.png"



function MobBigHero() {
    return (
        <div id='mob_bg'>
            <div className='mob_lannav'>
                <img className='mob_lannav_logo' src={logo}/>
                <img className='mob_lannav_burger' src={burger}/>
            </div>
            <h1>Secure your data.</h1>
            <h2>Find threats!</h2>
            <p>Elevate your cybersecurity with our comprehensive solutions.</p>
            <p> Safeguard your data and fortify your digital space for a resilient and safe business environment</p>
            <div className='mob_lanhero_btn_container'>
                <button>Get Started 🔥</button>
            </div>
            <div className='mob_lanhero_social_container'>
                <img src={social}/>
            </div>
        </div>
    )
}

export default MobBigHero
